import React from "react"
import Demo from "@views/demo"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - Book a Demo"
      keywords={[
        `engineid`,
        `security`,
        `demo`,
        `demonstration`,
        `access to your applications`,
        `password management`,
        `provision to cloud`,
        `permission management`,
        `single sign on`,
        `identity management`,
        `access management`,
      ]}
    />
    <Demo />
  </div>
)

export default IndexPage
